import React from 'react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import AppHeader from '../app-header';
import routes from '../../routes';
import akerBpLogo from './images/logo_abp.png';
import conocoPhillipsLogo from './images/logo_cop.png';
import equinorLogo from './images/logo_eqn.png';
import subseaLogo from './images/logo_sps.png';

const companies = [
  {
    name: 'Aker BP',
    path: '/abp/',
    logo: akerBpLogo,
    disabledInTest: true,
    disabledInProduction: true,
  },
  { name: 'ConocoPhillips', path: '/cop/', logo: conocoPhillipsLogo },
  {
    name: 'Equinor',
    path: '/eqn/',
    logo: equinorLogo,
    disabledInTest: true,
    disabledInProduction: true,
  },
  {
    name: 'Subsea Production System (Sandbox)',
    path: '/sps/',
    logo: subseaLogo,
    disabledInProduction: true,
  },
];

const CompanyPage = ({ isProduction }) => {
  return (
    <div className="layout__root">
      <div className="layout__head">
        <AppHeader />
      </div>
      <div className="layout__body company-layout">
        <div className="layout__sidebar col-3">
          <div className="layout__sidebar-container">
            <img
              src={`${process.env.PUBLIC_URL}/TIRC_MAIN_SPLASH_LEFT.png`}
              alt="TIRC splash"
            />
            <div className="gradient-overlay"></div>
          </div>
        </div>
        <main className="layout__content col-9 grey-bg">
          <div className="front-emptystate company-page">
            <div className="front-emptystate-headline-container">
              <Link
                className="portal-navigation-link company-back-link"
                to={routes.home}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                <span>Back</span>
              </Link>
              <div>
                <h1>TIRC</h1>
                <h3>Technical Information Requirement Catalog</h3>
              </div>
            </div>
            <section className="section-container company-section">
              <div className="company-intro">
                <h4>Company requirements</h4>
              </div>
              <div className="company-grid">
                {companies.map(company => {
                  const isDisabled =
                   company.disabledInTest || (isProduction && company.disabledInProduction);
                  const Card = isDisabled ? 'div' : 'a';

                  return (
                    <Card
                      aria-disabled={isDisabled || undefined}
                      className={`company-card${
                        isDisabled ? ' company-card--disabled' : ''
                      }`}
                      href={isDisabled ? undefined : company.path}
                      key={company.path}
                    >
                      <img
                        className="company-card__logo"
                        src={company.logo}
                        alt=""
                      />
                      <span className="company-card__name">
                        {company.name}
                      </span>
                    </Card>
                  );
                })}
              </div>
            </section>
          </div>
        </main>
        <img
          className="standard-image"
          alt="Standard Norge"
          title="Standard Norge"
          src={`${process.env.PUBLIC_URL}/Norsok_ORG.png`}
        />
      </div>
    </div>
  );
};

export default CompanyPage;
